// Local queue for offline invoices. Stored in localStorage so it survives reloads.
// Each item keeps the exact body we would POST to /pos/invoices, so syncing is just a replay.
const KEY = "mbv_offline_invoices";
const SEQ = "mbv_offline_seq";

const notify = () => window.dispatchEvent(new Event("mbv-queue-changed"));

export function getQueue() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
  catch (e) { console.warn("Cola offline corrupta, se reinicia:", e); return []; }
}

function saveQueue(q) {
  localStorage.setItem(KEY, JSON.stringify(q));
  notify();
}

export function enqueue(body, meta = {}) {
  const q = getQueue();
  const seq = Number(localStorage.getItem(SEQ) || "0") + 1;
  localStorage.setItem(SEQ, String(seq));
  const number = `OFFLINE-${seq}`;
  q.push({
    qid: `${Date.now()}-${seq}`,
    number,
    body,
    status: "pending",
    error: "",
    created_at: new Date().toISOString(),
    ...meta,
  });
  saveQueue(q);
  return number;
}

export function updateItem(qid, patch) {
  saveQueue(getQueue().map((i) => (i.qid === qid ? { ...i, ...patch } : i)));
}

export function removeItem(qid) {
  saveQueue(getQueue().filter((i) => i.qid !== qid));
}

export function counts() {
  const q = getQueue();
  return {
    total: q.length,
    pending: q.filter((i) => i.status === "pending").length,
    error: q.filter((i) => i.status === "error").length,
  };
}
